import config from "./config";
import apiService from "./apiService";
export default {
  async getClientInformation(clientId,typeid=0) {
    let clientApiUrl = `${config.clientApiUrl}/${clientId}/${typeid}/0/0/0`;
    return apiService.get(clientApiUrl);
  },
};